export default __webpack_public_path__ + "static/media/Banner_amazon_verano_gmm_330x330.8160adf3.webp";